import { render, staticRenderFns } from "./footer-buttons.vue?vue&type=template&id=4ea47038&"
import script from "./footer-buttons.vue?vue&type=script&lang=js&"
export * from "./footer-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports